import styled from 'styled-components';

import { SpaceBetweenBlock } from '../../../styled';

export const NotificationBlock = styled.div`
  top: 17px;
  right: 11px;
  position: fixed;
  z-index: 1001;
`;

export const NotificationWrapper = styled.div<{ error: boolean }>`
  color: ${(props) => (props.error ? props.theme.colors.danger : props.theme.colors.action)};
  width: 350px;
  padding: 12px;
  margin-bottom: 8px;
  background-color: ${(props) => (props.error ? '#f9e7ec' : '#e0f8ef')};
  border: 1px solid
    ${(props) => (props.error ? props.theme.colors.danger : props.theme.colors.action)};
  border-radius: 4px;
  display: flex;
  h3,
  p {
    color: ${(props) => (props.error ? props.theme.colors.danger : props.theme.colors.action)};
  }
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  display: inherit;
`;

export const NotifyHeadWrapper = styled(SpaceBetweenBlock)`
  width: 100%;
  align-items: start !important;
`;

export const NotifyTextWrapper = styled.div`
  margin-left: 8px;
`;

export const NotificationTitle = styled.h3`
  ${(props) => props.theme.typography.description};
  font-weight: 600;
`;

export const NotificationText = styled.p`
  ${(props) => props.theme.typography.caption};
`;
